const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/eCheckin/components/fields/EMailField.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { useIntl } from 'react-intl';
import { MessageDescriptor } from '@formatjs/intl';
import { CIS4mTextField } from '@cistec/common_web/modules/CIS4m/components/CIS4mTextField';
import { validateEmail, ValidationFunction } from '@cistec/common_web/components/Forms/utils/validation';

interface Props {
    label: string | MessageDescriptor;
    path: string;
    checkValidity?: ValidationFunction;
    hidden?: boolean;
    required?: boolean;
}

export const EMailField = forwardRef((props: Props, ref: any) => {
    const { formatMessage } = useIntl();

    const textFieldRef = useCIS4m(ref);

    const label = typeof props.label === 'string' ? props.label : formatMessage(props.label);
    const hidden = props.hidden ?? false;
    const required = props.required ?? false;

    const checkValidity = props.checkValidity ?? validateEmail;

    return (
        <CIS4mTextField
            ref={textFieldRef}
            label={label}
            path={props.path}
            checkValidity={checkValidity}
            hidden={hidden}
            required={required}
        />
    );
});

EMailField.displayName = 'EmailField';
